import { CookieManagerService } from './../../services/cookie-manager.service';
import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.css']
})
export class InfoPopupComponent implements OnInit {

  popupModal: any;

  constructor( private cookieManagerService: CookieManagerService) { }

  ngOnInit() {

  }

  ngAfterViewInit() {
    // this.popupModal = $('#infoPopup');
  }

    /**
   * modal close using hide event
   *
   * @memberof AppLoginComponent
   */
  modalClose() {
    this.popupModal.modal('hide');
		this.cookieManagerService.setCookie("isPopupClosed", "true",false, 0.5);
  }


}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/popup/info-popup/info-popup.component.ts